// extracted by mini-css-extract-plugin
module.exports = {"textInput":"ExternalLinksConfigContainer-textInput-bbb1607ca400ce9673c4f8e4e86c907b"};